import { ArrowUpRight, Menu, X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

const links = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Equipment", href: "#equipment" },
  { label: "Anfrage", href: "#anfrage" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header" data-testid="site-header">
      <a className="brand" href="#top" data-testid="site-logo-link">
        <img
          className="brand-logo-image"
          src="https://customer-assets-jai6qajn.emergentagent.net/job_equipment-showcase-17/artifacts/105umop1_E6F67143-40D3-4A18-9B43-F601B2613948-Photoroom.png"
          alt="AB Licht & Ton Eventtechnik"
          data-testid="site-logo-image"
        />
        <span className="brand-text">EVENTTECHNIK</span>
      </a>
      <nav className={`nav-links ${open ? "nav-open" : ""}`} data-testid="site-navigation">
        {links.map((link) => (
          <a key={link.href} href={link.href} onClick={() => setOpen(false)} data-testid={`navigation-${link.label.toLowerCase()}-link`}>
            {link.label}
          </a>
        ))}
      </nav>
      <div className="header-actions">
        <Link to="/admin" className="admin-link" data-testid="admin-login-link">
          Admin
        </Link>
        <a className="header-cta" href="#anfrage" data-testid="header-inquiry-link">
          Jetzt anfragen <ArrowUpRight size={16} />
        </a>
        <button className="menu-button" onClick={() => setOpen(!open)} data-testid="mobile-navigation-button" aria-label="Navigation öffnen">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
    </header>
  );
}